<template>
  <div class="contact-wrapper">
    <div class="contact section">
      <div class="contact-inner">
        <div class="container">
          <h2 class="section-title">Skontaktuj się z nami!</h2>
          <contact-row
            v-for="office in offices"
            :office="office"
            :key="office.address + office.city"
          />
        </div>
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <dynamic-content class="info" :content="footer" />
          </div>
        </div>
      </div>
    </div>
    <div class="breakdown-wrapper">
      <svg class="delimiter" viewBox="0 0 100 40" preserveAspectRatio="none">
        <path class="delimiter__shape" d="M 0 0 L 100 40 L 0 40 L 0 0" />
      </svg>
      <div class="breakdown section" id="breakdown-contact">
        <contact-breakdown
          :breakdown-header="breakdownHeader"
          :breakdown="breakdown"
        />
      </div>
      <svg class="delimiter" viewBox="0 0 100 40" preserveAspectRatio="none">
        <path class="delimiter__shape" d="M 0 0 L 100 40 L 100 0 L 0 0" />
      </svg>
    </div>
  </div>
</template>

<script>
import ContactRow from "./ContactRow";
import ContactBreakdown from "./ContactBreakdown";
import { DynamicContent } from "%helpers";

export default {
  name: "contact",

  components: {
    ContactRow,
    DynamicContent,
    ContactBreakdown
  },

  props: {
    offices: Array,
    footer: String,
    breakdownHeader: String,
    breakdown: Object
  }
};
</script>

<style lang="scss" scoped>
.contact {
  background: url("../../assets/img/smartphone.jpg") no-repeat center / cover,
    $info;
  padding: 0;
  margin: 8rem 0 0;
}

.contact-inner {
  background: rgba($black, 0.2);
  padding: 5rem 0 12rem;
}

.info {
  font-style: italic;
  font-family: $family-sans-serif;
  color: $white;
  padding: 2rem;
}

$breakdown-color: $info;

.breakdown-wrapper {
  position: relative;
  top: -7rem;
}

.breakdown {
  background-color: $breakdown-color;

  &.section {
    padding-top: 0;
  }
}

.delimiter {
  width: 100%;
  height: 7rem;
  display: block;

  @include tablet {
    height: 7rem;
  }

  @include mobile {
    height: 5rem;
  }

  @include until($small-mobile) {
    height: 3rem;
  }

  &__shape {
    fill: $breakdown-color;
    stroke: $breakdown-color;
    stroke-width: 0;
  }
}
</style>
